import axios from '../../axios';
import * as types from './mutation-types'
const state = () => ({
	products: ''
})
const actions = {
	fetchProducts({ commit }, slug) {
		return axios.get(`/categories/${slug}`).then(response => commit(types.STORE_PRODUCTS, response.data))
	}
}
const mutations = {
	[types.STORE_PRODUCTS] (state, product) {
		state.products = product.categoriesProduct;
	}
}
export default {
	namespaced: true,
	state,
	actions,
	mutations
}
